<form [formGroup]="productBrandForm">
  <section class="container">
    <div class="product-info top" i18n="@@ProductBrandInfoPageTitle">
      Product & Brand Info
    </div>
    <section>
      <div class="title top" i18n="@@ProductBrandInfoProductTitle">Product</div>
      <div class="title-val">
        {{ productName }}
      </div>
    </section>
    @if (productName !== MOBILE_APP_WATCH) {
    <section class="title top">
      <div>
        <app-custom-validator-chips
          label="Classes"
          controlName="classesControl"
          placeHolder="Enter Classes..."
          i18n-placeHolder="@@ProductBrandInfoInputEnterClassesPlaceHolder"
          i18n-label="@@ProductBrandInfoInputClassesLabel"
          [chips]="classes"
          [customFormat]="true"
          [formatData]="formatData"
          [customValidatorFn]="customClassesValidatorFun"
        >
        </app-custom-validator-chips>
      </div>
    </section>
    }
    <section class="goods-services">
      <span>
        <label class="title" i18n="@@ProductBrandInfoGoodsAndServicesTextLabel"
          >Goods and Services (optional)</label
        >
        <mat-icon
          class="material-symbols-outlined info-icon"
          matTooltip="{{ toolTipMessage }}"
          >info</mat-icon
        >
      </span>
      <mat-form-field appearance="outline">
        <textarea
          class="font-val"
          matInput
          formControlName="goodsAndServicesControl"
          #goodsAndServicesInput
          maxlength="{{ textAreaMaxlength }}"
          cdkTextareaAutosize
          cdkAutosizeMinRows="{{ textAreaMinRow }}"
          cdkAutosizeMaxRows="{{ textAreaMaxRow }}"
          (blur)="sanitizeField('goodsAndServicesControl')"
        ></textarea>
      </mat-form-field>
      <div>
        <mat-hint class="remaining-characters">
          {{ remainingCharacters(goodsAndServicesInput.value) }}/{{
            textAreaMaxlength
          }}
          <ng-container i18n="@@ProductBrandInfoGoodsAndServicesHint">
            characters
          </ng-container>
        </mat-hint>
      </div>
    </section>
  </section>
</form>
